import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import ProblemsField from 'forms/fields/ProblemsField';
import CityField from 'forms/fields/CityField';
import DistrictField from 'forms/fields/DistrictField';
import PairsCheckboxField from 'forms/fields/PairsCheckboxField';
import OfflineCheckboxField from 'forms/fields/OfflineCheckboxField';
import SpecialistSearchField from 'forms/fields/SpecialistSearchField';
import Model from '../../../../model';

import './index.sass';

const { block, el } = bem('filter-block');

const FilterBlock = ({disabled}) => {

    const { filtered, resetFilters } = Model.specialistFilter;

    useEffect(() => {
        return () => resetFilters();
    }, []);

    const {
        problemsOptions, setFilter,
        filters: { problems: problem, cities: city, districts: district, workingWithPairs, workingOffline },
        citiesOptions, districtsOptions, workingWithPairsOptions, workingOfflineOptions, setName, name
    } = Model.specialistFilter;

    const setProblem = useCallback((problem) => {
        setFilter('problems', problem);
    }, []);
    const setCity = useCallback((city) => {
        setFilter('cities', city);
    }, []);
    const setDistrict = useCallback((district) => {
        setFilter('districts', district);
    }, []);
    const setWorkingWithPairs = useCallback((workingWithPairs) => {
        setFilter('workingWithPairs', workingWithPairs)
    }, []);
    const setWorkingOffline = useCallback((workingOffline) => {
        setFilter('workingOffline', workingOffline)
    }, []);

    const problemsProps = {
        problemsOptions,
        problem,
        setProblem
    }

    const cityProps = {
        citiesOptions,
        setCity,
        city,
        workingOffline
    }

    const districtProps = {
        districtsOptions,
        setDistrict,
        district,
        city,
        workingOffline
    }

    const workingWithPairsProps = {
        workingWithPairs,
        setWorkingWithPairs,
        workingWithPairsOptions
    }

    const workingOfflineProps = {
        workingOffline,
        setWorkingOffline,
        workingOfflineOptions
    }


    const names = useMemo(() => filtered.map(spec => spec.data.name), [ filtered ]);

    return (
        <div className={ block({ disabled }) }>
            <div className={el('first-row')}>
                <SpecialistSearchField placeholder = 'Поиск по имени' names={names} setName={ setName } name={ name } />
                <ProblemsField { ...problemsProps }/>
            </div>
            <div className={el('second-row')}>
                <PairsCheckboxField { ...workingWithPairsProps }/>
                <div className={el('offline-fields')}>
                    <OfflineCheckboxField { ...workingOfflineProps } />
                    <span className={el('place-fields', { hidden: !workingOffline })}>
                        <CityField { ...cityProps }/>
                        <DistrictField { ...districtProps }/>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default observer(FilterBlock);
